import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
import cn from "../../utils/cn";
const Table = ({ className, children, style }) => {
    return (_jsx("table", { className: cn("box-border w-full caption-bottom border-collapse text-sm", className), style: style, children: children }));
};
Table.displayName = "Table";
export default memo(Table);
